// extracted by mini-css-extract-plugin
export default {"marker":"style_marker__tN2Xg","container":"style_container__kUg3Z","title":"style_title__lXkY+"};